import ReactDOM from "react-dom";

import "./index.scss";

const Modal = (props: any) => {
  return (
    <>
      {ReactDOM.createPortal(
        <div className="component modal">
          {props.children}
          <style>{`body {overflow: hidden !important;}`}</style>
        </div>,
        document.querySelector("body")!
      )}
    </>
  );
};

export default Modal;
